<div class="base-container">
  <a href="{{ environment.publicUrl }}">
    <img src="assets/images/logo/logo-bonsalaire.svg" />
  </a>

  <div class="cursor-pointer md:hidden" (click)="mobileOpened = true">
    <svg-icon
      src="assets/images/svg-icons/icon-menu.svg"
      [svgStyle]="{ 'width.px': 24 }"
    ></svg-icon>
  </div>

  <div
    class="mobile-mask md:hidden"
    (click)="mobileOpened = false"
    [class.-active]="mobileOpened"
  ></div>

  <nav [class.-active]="mobileOpened">
    <div class="flex flex-col min-h-full">
      <a href="{{ environment.publicUrl }}" class="mobile-logo">
        <img src="assets/images/logo/logo-bonsalaire.svg" />
      </a>
      <ul>
        <li>
          <a href="{{ environment.publicUrl }}/a-propos/">A propos</a>
        </li>
        <li>
          <a href="{{ environment.publicUrl }}/actualites/">Actualités</a>
        </li>
        <li>
          <a [routerLink]="['/user/login']" class="-active">
            <div class="mr-4 text-primary">
              <svg-icon
                src="assets/images/svg-icons/icon-lock.svg"
                [svgStyle]="{ 'width.px': 18 }"
              ></svg-icon>
            </div>
            Mon espace
          </a>
        </li>
      </ul>
      <div
        class="mobile-social flex justify-center items-center px-6 flex-shrink-0 border-t border-primary md:hidden"
      >
        <a href="https://www.facebook.com/bonsalairecom" target="_blank" title="facebook">
          <svg-icon src="assets/images/svg-icons/icon-facebook.svg"></svg-icon>
        </a>
      </div>
    </div>
  </nav>
</div>
